import { SWMS_ALL_ACTIVITY_URL, SWMS_ACTIVITY_FILTERS_URL, SWMS_ADD_UPDATE_ACTIVITY_URL, SWMS_ACTIVITY_ORDER_URL, SWMS_ACTIVITY_CONSEQUENCE_ORDER_URL, SWMS_LIKELIHOOD_ORDER_URL, SWMS_CONSEQUENCES_ORDER_URL, SWMS_ACTIVITY_HAZARD_ORDER_URL, SWMS_APPROVERS_LIST_URL, ORGANIZATION_USERS_URL_V2 } from "../../dataProvider/constant";
import { baseApiInstance, scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const getSwmsActivityFilters = (abortController) => () => {
  return scopeApiInstance.get(SWMS_ACTIVITY_FILTERS_URL, { ...abortController }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getAllSwmsActivities = (page = 1, params = {}, abortController) => () => {
  return scopeApiInstance.get(SWMS_ALL_ACTIVITY_URL, { params: { page, ...params }, ...abortController }).then((res) => {
    if (res && res.data && res.data.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const addUpdateActivity = (formData) => () => {
  return scopeApiInstance.post(SWMS_ADD_UPDATE_ACTIVITY_URL, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const updateActivityOrder = (formData) => () => {
  return scopeApiInstance.put(SWMS_ACTIVITY_ORDER_URL, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const updateConsequenceOrder = (formData) => () => {
  return scopeApiInstance.put(SWMS_ACTIVITY_CONSEQUENCE_ORDER_URL, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve("Order Updated Successfully.");
    } else {
      return Promise.reject()
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const updateHazardOrder = (formData) => () => {
  return scopeApiInstance.put(SWMS_ACTIVITY_HAZARD_ORDER_URL, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve("Order Updated Successfully.");
    } else {
      return Promise.reject()
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const updateLikelihoodOrder = (formData) => () => {
  return scopeApiInstance.put(SWMS_LIKELIHOOD_ORDER_URL, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const updateConsequenceOrderV2 = (formData) => () => {
  return scopeApiInstance.put(SWMS_CONSEQUENCES_ORDER_URL, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    })
}

export const getSwmsActivityDetails = (id, params = {}, abortController = {}) => () => {
  return scopeApiInstance.get(`${SWMS_ALL_ACTIVITY_URL}/${id}`, { params: { ...params }, ...abortController }).then((res) => {
    if (res && res.data && res.data.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}


export const addSwmsActivityV2 = (formData) => () => {
  return scopeApiInstance.post(SWMS_ALL_ACTIVITY_URL, formData).then((res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const updateSwmsActivityV2 = (formData, activityId) => () => {
  return scopeApiInstance.put(`${SWMS_ALL_ACTIVITY_URL}/${activityId}`, formData).then((res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getActivityHistory = (id, params = {}, abortController = {}) => () => {
  return scopeApiInstance.get(`${SWMS_ALL_ACTIVITY_URL}/${id}/history`, { params: { ...params }, ...abortController }).then((res) => {
    if (res && res.data && res.data.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getSwmsApproverManagers = () => () => {
  return baseApiInstance.get(SWMS_APPROVERS_LIST_URL).then((res) => {
    if (res && res.data && res.data.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getSwmsOptionalUsers = (abortController = {}) => () => {
  return baseApiInstance.get(ORGANIZATION_USERS_URL_V2, { params: { page: 0 }, ...abortController }).then((res) => {
    if (res && res.data && res.data.data && Array.isArray(res.data.data.orgUsers)) {
      return Promise.resolve(res.data.data.orgUsers);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const sendActivityForApproval = (formData, activityId) => () => {
  return scopeApiInstance.post(`${SWMS_ALL_ACTIVITY_URL}/${activityId}/submit-for-approval`, formData).then((res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const approveRejectActivity = (formData, activityId) => () => {
  return scopeApiInstance.post(`${SWMS_ALL_ACTIVITY_URL}/${activityId}/approve-reject`, formData).then((res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const toggleActivityStatus = (formData, activityId) => () => {
  return scopeApiInstance.patch(`${SWMS_ALL_ACTIVITY_URL}/${activityId}/toggle-active`, formData).then((res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}
